import { createTheme } from "@mui/material";
import React, { createContext, useMemo, useState } from "react";

export const themeOptions = (mode) => {
  return {
    palette: mode === "light" ? lightModePalette : darkModePalette,
    typography: {
      h1: {
        fontFamily: "Kalam",
        fontSize: "3.5rem",
        color: "#fff",
      },
      h2: {
        fontFamily: "Kalam",
        fontSize: "3.25rem",
      },
      h3: {
        fontFamily: "Kalam",
        fontSize: "3rem",
      },
      h4: {
        fontFamily: "Kalam",
        fontSize: "2.75rem",
      },
      h5: {
        fontFamily: "Kalam",
        fontSize: "2.5rem",
      },
      h6: {
        fontFamily: "Kalam",
        fontSize: "2.25rem",
      },
      body1: {
        fontFamily: "Kalam",
        fontSize: "1.8rem",
      },
      body2: {
        fontFamily: "Kalam",
        fontSize: "1.3rem",
        fontWeight: 400,
        lineHeight: 1.4,
        letterSpacing: "0.03em",
        color: "#fff",
      },
      body3: {
        fontFamily: "Kalam",
        fontSize: "1.5rem",
        fontWeight: 400,
        lineHeight: 1.4,
        letterSpacing: "0.03em",
        color: "#fff",
      },
      button: {
        fontFamily: "Kalam",
        fontSize: "1.2rem",
        fontWeight: "bold",
      },
      caption: {
        fontFamily: "Kalam",
      },
      overline: {
        fontFamily: "Kalam",
        fontSize: "0.9rem",
      },
      subtitle1: {
        fontFamily: "Kalam",
        fontSize: "1rem",
      },
      subtitle2: {
        fontFamily: "Kalam",
        fontSize: "0.8rem",
      },
    },
    components: {
      MuiIconButton: {
        styleOverrides: {
          root: {
            m: 0,
            fontSize: "2.5rem",
            color: "#9C7945",
            "&:hover": {
              borderBottom: "4px solid #fff",
              background: "inherit",
              
            }
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: ({ ownerState }) => ({
            ...(ownerState.className === "active-button" && {
              color: "#fff",
            }),
            "&:hover": {
              borderBottom: "2px solid #fff",
              background: "inherit",
            },
          }),
        },
      },
      MuiIcon: {
        styleOverrides: {
          root: {
            fontSize: "2.5rem",
            color: "#9C7945",
          },
        },
      },
      MuiSvgIcon: {
        styleOverrides: {
          root: {
            fontSize: "2.5rem",
            color: "#9C7945",
          },
        },
      },
      // MuiAppBar: {
      //   styleOverrides: {
      //     root: ({ theme }) => ({
      //       ...(theme.breakpoints.up("sm") && {
                
      //         }),
      //     })
      //   },
      // },
    },
  };
};

const darkModePalette = {
  mode: "dark",
  primary: {
    main: "#7b7f92",
    light: "#9598A7",
    dark: "#565866",
  },
  secondary: {
    main: "#000000",
  },
  info: {
    main: "#0288d1",
  },
  divider: "#7b7f92",
  text: {
    primary: "#7b7f92",
    secondary: "#9C7945",
    hint: "#ffffff",
    disabled: "rgba(255, 255, 255, 0.5)",
  },
};

const lightModePalette = {
  mode: "light",
  primary: {
    main: "#9C7945",
    light: "#AF936A",
    dark: "#6D5430",
    contrastText: "#FFFFFF",
  },
  secondary: {
    main: "#ffffff",
    light: "#FFFFFF",
    dark: "#B2B2B2",
    contrastText: "rgba(0,0,0,0.85)",
  },
  divider: "#9C7945",
  text: {
    primary: "#9C7945",
    secondary: "#7b7f92",
    hint: "#ffffff",
    disabled: "rgba(255, 255, 255, 0.5)",
  },
};

//Create a context - enables accessing the 'function created' from consumer till deep down the application
//'function created' - create an empty function
export const ColorModeContext = createContext({
  toggleColorMode: () => {},
});

//create a useMode function that returns the theme & toggle function
export const useMode = () => {
  //a state variable to maintain the mode of the application
  const [mode, setMode] = useState("light");

  //functions are defined which manipulates the mode of the application
  const colorMode = useMemo(
    () => ({
      toggleColorMode: () =>
        setMode((prev) => (prev === "light" ? "light" : "dark")),
    }),
    []
  );

  //function defined to create and return the theme as per mode's value
  const theme = React.useMemo(() => createTheme(themeOptions(mode)), [mode]);

  return [theme, colorMode];
};
